



























































import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import pcCodeStore, { PcCodeStore } from "@/modules/pcCode/services/PcCodeStore";
import store, { MetRiportStore } from "../services/MetRiportStore";
import MetRiportItem from "../models/MetRiportItem";
import globalStore from "@/models/GlobalStore";
import dayjs from "dayjs";
import { t } from "@/plugins/i18n";

interface Data {
  store: MetRiportStore;
  pcCodeStore: PcCodeStore;
  transactions: any[];
}

interface Methods {
  formatDate(date?: string, time?: string): string;
}

interface Computed {
  columns: ApiSearchColumn[];
  url: string;
  sum: number;
}

interface Props {
  item: MetRiportItem;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    ApiSearchPage,
  },

  props: {
    item: { type: Object, required: true },
  },

  async beforeMount() {
    await pcCodeStore.loadStore();
    pcCodeStore.getDmsNatFromCode(this.item.dmsCode);
  },

  data() {
    return {
      store,
      pcCodeStore,
      globalStore: globalStore,
      transactions: [],
    };
  },

  computed: {
    url() {
      return `met-riport/${this.item.metisHead}/item/details/${this.item.id}/${encodeURIComponent(this.item.dmsCode || "")}`;
    },
    columns: function () {
      return [
        {
          field: "trans",
          title: t("TranzakcioAzonosito"),
          type: ColumnType.Right,
        },
        {
          field: "headAccEvent",
          title: t("Esemeny"),
        },
        {
          field: "headTransTypeName",
          title: t("TranzakcioTipusa"),
        },
        {
          field: "itemPeriodname",
          title: t("Periodus"),
          type: ColumnType.Right,
          // filterable: false,
        },
        {
          field: "bookinDate",
          title: t("MetisRiport_TranzakcioIdeje"),
          cell: "bookinDate",
          // filterable: false,
        },
        {
          field: "itemPartner",
          title: t("Partner"),
          width: 200,
          // filterable: false,
        },
        {
          field: "prefix",
          title: t("Prefix"),
        },
        {
          field: "accDate",
          title: t("KonyvelesDatuma"),
          cell: "accDate",
          // filterable: false,
        },
        {
          field: "itemUser",
          title: t("MetisRiport_Konyvelte"),
          // filterable: false,
        },
        {
          field: "itemBookTypeName",
          title: t("MetisRiport_KonyvelesTipusa"),
        },
        {
          field: "headStorno",
          title: t("MetisRiport_SztornoTranzakcio"),
          cell: "headStorno",
          type: ColumnType.Right,
          width: 50,
          // filterable: false,
        },
        {
          field: "itemAccNoVal",
          title: t("MetisRiport_FkSzam"),
          type: ColumnType.Right,
        },
        {
          field: "itemAccNoName",
          title: t("MetisRiport_FkSzamMegnevezes"),
        },
        {
          field: "accSign",
          title: "T/K",
          cell: "accSign",
          // filterable: false,
        },
        {
          field: "total",
          title: t("MetisRiport_KonyveltOsszeg"),
          cell: "total",
          type: ColumnType.Right,
        },
        {
          field: "itemCarName",
          title: t("MetisRiport_KapcsolodoGepjarmu"),
        },
        {
          field: "k2DInvNo",
          title: t("MetisRiport_KapcsolodoSzamla"),
          // filterable: false,
        },
        {
          field: "headStoreIn",
          title: t("Betarolas"),
          type: ColumnType.Right,
        },
        {
          field: "headStoreOut",
          title: t("MetisRiport_Kitarolas"),
          type: ColumnType.Right,
        },
      ];
    },
    sum() {
      return this.transactions.reduce((acc, item) => acc + item.total, 0);
    },
  },

  methods: {
    formatDate(date, time = "") {
      return `${dayjs(date).format("YYYY.MM.DD")}${time !== "" ? ` ${(time || "").substring(11, 16)}` : ``}`
    },
  },
});
